
import React from 'react';

interface GuessListProps {
  guesses: string[];
  correctTitle: string;
}

const GuessList: React.FC<GuessListProps> = ({ guesses, correctTitle }) => {
  return (
    <div className="space-y-1.5 lg:space-y-1.5 w-full">
      {Array.from({ length: 6 }).map((_, i) => {
        const guess = guesses[i];
        const isCorrect = guess && guess.toLowerCase() === correctTitle.toLowerCase();
        
        return (
          <div
            key={i}
            className={`w-full h-10 sm:h-12 lg:h-[34px] rounded-lg border flex items-center px-3 sm:px-5 lg:px-4 transition-all duration-300 border-[1px] ${
              !guess 
                ? 'border-zinc-300 dark:border-zinc-800 bg-transparent opacity-80' 
                : isCorrect 
                  ? 'border-green-600 dark:border-green-500 bg-green-500/10 text-green-700 dark:text-green-400 shadow-md' 
                  : 'border-zinc-400 dark:border-zinc-700 bg-zinc-100 dark:bg-zinc-900/50 text-ink dark:text-off-white shadow-sm'
            }`}
          >
            <span className={`mr-3 sm:mr-4 lg:mr-3 tabular-nums text-[10px] sm:text-xs lg:text-[10px] font-extrabold ${
              !guess ? 'text-zinc-400 dark:text-zinc-600' : 'text-zinc-600 dark:text-zinc-400'
            }`}>
              {i + 1}
            </span>
            <span className="truncate uppercase text-[10px] sm:text-[12px] lg:text-[11px] font-bold tracking-wide flex-1">
              {guess || ''}
            </span>
            {guess && (
              <div className="ml-2 sm:ml-3 lg:ml-2 flex items-center shrink-0">
                {isCorrect ? (
                  <svg className="w-4 h-4 sm:w-5 sm:h-5 lg:w-4 lg:h-4 text-green-600 dark:text-green-500" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                ) : (
                  <svg className="w-4 h-4 sm:w-5 sm:h-5 lg:w-4 lg:h-4 text-red-600 dark:text-red-500" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                  </svg>
                )}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default GuessList;
